import { defineComponent } from 'vue';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
export default defineComponent({
    name: 'Flow',
    components: {
        LottieAnimation,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const baseUrl = process.env.BASE_URL?.substring(1) || '';
        return {
            baseUrl,
            path: `${baseUrl}resources/lottie/${props.name}.json`,
        };
    },
});
